import React from 'react';
import ValidationErrorLabel from '../../ValidationErrorLabel/ValidationErrorLabel';
import classes from './textField.module.scss';
import colors from '../../../../scss/colors';

const errorPositions = {
  TOP: 'top',
  BOTTOM: 'bottom'
};

function TextField({
    value,
    onChange,
    id,
    name,
    readOnly = false,
    type = 'text',
    disabled,
    label,
    error,
    errorText,
    placeholder,
    errorPosition = errorPositions.TOP,
    isTextArea = false,
    rows = '3',
    clearable,
    onClick,
    counter,
    labelClass = '',
    inputClass = ''
}) {

  return (
    <div className={classes.container}>
      {!!label && <label className={labelClass} htmlFor={id}>{label}</label>}
      {errorPosition === errorPositions.TOP && !!error && !!errorText && <ValidationErrorLabel message={errorText} />}
      {isTextArea ? (
        <textarea
          rows={rows}
          className={`${inputClass || ''} ${classes.inputElement} ${classes.textArea} ${clearable ? classes.clearable : ''}`}
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          readOnly={readOnly}
          onClick={onClick}
        />
      ) : (
        <input
          className={`${inputClass || ''} ${classes.inputElement} ${clearable ? classes.clearable : ''}`}
          type={type}
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          readOnly={readOnly}
          onClick={onClick}
        />
      )}
      {!!counter && (
        <ValidationErrorLabel
          color={counter.qty > counter.limit ? colors.RED_ERROR : colors.LIGHT_GREY}
          message={`${counter.qty || '0'}/${counter.limit}`}
          fontSize="10px"
        />
      )}
      {errorPosition === errorPositions.BOTTOM && !!error && !!errorText && (
        <ValidationErrorLabel message={errorText} />
      )}
    </div>
  );
}

export default TextField;
